import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import { Link } from 'react-router';
import Gear from '../../partials/gear';
import ScrollAnimation from 'react-animate-on-scroll';
import _ from 'lodash';
import { getBase64, } from '../../../helpers';
import request from 'superagent';
import config from '../../../config';
import { Popover, PopoverBody, PopoverHeader, } from 'reactstrap';

class AddSponsor extends React.Component {
    state = {
        sponsor: null,
        microTransac: false,
        deleting: false
    }
    componentWillMount() {
        const { sponsors = [], sponsorsActions, params } = this.props, { id } = params;
        if (id) {
            if (sponsors && sponsors.length && _.find(sponsors, a => parseInt(a.id, 10) === parseInt(id, 10))) {
                this.setState({ sponsor: _.find(sponsors, a => parseInt(a.id, 10) === parseInt(id, 10)) })
            } else {
                this.setState({ microTransac: true }, () => {
                    sponsorsActions && sponsorsActions.fetch(id);
                });
            }
        } else {
            this.setState({ sponsor: {} });
        }
    }
    componentWillReceiveProps = nextProps => {
        const { sponsor } = nextProps;
        this.setState({ sponsor, microTransac: false });
    }
    logout = () => {
        fakeAuth.signout(() => {
            this.props.router.push('/admin');
        });
    }
    handleAvatar = e => {
        const { sponsor } = this.state;
        getBase64(e.target.files[0]).then(data => {
            sponsor.Logo = data;
            this.setState({ sponsor });
        });
    }
    save = () => {
        const { sponsor } = this.state, { sponsorsActions } = this.props;
        sponsor.Name = this.txtName.value;
        this.setState({ microTransac: true }, () => {
            request[sponsor.id ? 'patch' : 'post'](`${config.apiEndpoint}/api/cs/v2/sponsors${sponsor.id ? `/${sponsor.id}` : ''}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .send(sponsor)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        sponsorsActions.fetch();
                        this.props.router.push('/admin/sponsors');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    toggleDelete = () => this.setState({ deleting: !this.state.deleting });
    doDelete = () => {
        const { sponsor } = this.state, { sponsorsActions } = this.props;
        this.setState({ microTransac: true }, () => {

            request.del(`${config.apiEndpoint}/api/cs/v2/sponsors/${sponsor.id}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        sponsorsActions.fetch();
                        this.props.router.push('/admin/sponsors');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    render() {
        const { sponsor = {}, microTransac } = this.state;
        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/sponsors" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">SPONSORS | ADD</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={5} onLogout={this.logout} animated={false} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix padding-right">
                        {sponsor &&
                            <ScrollAnimation animateIn="fadeInRight" animateOnce={true}>
                                <figure className="card w-100 p-4 bg-black">
                                    <label htmlFor="name" className="white">Sponsor Name</label>
                                    <input className="" type="text" required ref={(i) => this.txtName = i} defaultValue={sponsor.Name} />

                                    <div className="car w-100 p-4 d-flex flex-column justify-content-center pointer">
                                        <input type="file" id="fi" onChange={this.handleAvatar} className="hide" ref={i => this.avatarFU = i} />
                                        <label htmlFor="fi" className="d-flex flex-column justify-content-center h-100">
                                            {!sponsor.Logo && <i className='fas fa-plus font-50 align-self-center green' />}
                                            {sponsor.Logo && <img alt="" style={{ height: 100 }} src={sponsor.Logo} className="align-self-center" />}
                                            <span className="margin-top-half align-self-center white">{sponsor.Logo ? 'Change' : 'Add'}{' '}Logo</span>
                                        </label>
                                    </div>
                                    <div className="text-center">
                                        <span className="font-10 blue">(*) Remember this logo goes against a black background; mind the contrast.</span>
                                    </div>
                                    <div className="d-flex flex-row">
                                        {sponsor.id && <button id="btn-delete" onClick={this.toggleDelete} type="button" style={{ width: 100 }} className="align-self-center btn-red text-center">REMOVE</button>}
                                        <Link to="/admin/sponsors" className="align-self-center btn-link text-center ml-auto margin-right white">CANCEL</Link>
                                        <button onClick={this.save} type="submit" style={{ width: 100 }} className="align-self-center btn-black text-center">SAVE</button>
                                    </div>
                                    {sponsor.id && <Popover placement="bottom" isOpen={this.state.deleting} target={`btn-delete`} toggle={this.toggleDelete}>
                                        <PopoverHeader>Are you sure?</PopoverHeader>
                                        <PopoverBody className="d-flex flex-row justify-content-center">
                                            <button className="btn btn-success btn-sm" onClick={this.doDelete}>Yes, Delete it</button>
                                            <button className="btn btn-danger btn-sm" onClick={this.toggleDelete}>No, Cancel</button>
                                        </PopoverBody>
                                    </Popover>}
                                </figure>
                            </ScrollAnimation>}
                    </section>
                </div>
            </section>
        )
    }
}

export default AddSponsor;



// WEBPACK FOOTER //
// ./src/components/private/sponsors/add.js